<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type === 'success' || alert.type === 'warning'" class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        <p v-if="alert.type !== 'danger'">{{alert.message}}</p>
        <ul v-else>
          <li v-for="e in alert.message">{{e}}</li>
        </ul>
      </b-alert>
    </template>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-pencil-square-o mr-5"></i>{{'new_labels' | translate}}</h2>
      </div>
      <div class="box-controls">
          <multiselect
            v-model="company"
            :options="companies"
            :placeholder="'select_one' | translate"
            label="name"
          >
          </multiselect>
      </div>
      <div v-if="company.id === 0" class="box-body">
        <div class="callout callout-info">
          <h4><i class="fa fa-exclamation-triangle mr-5"></i>{{'info' | translate}}</h4>
          <p>{{'no_label_existing_chose_company' | translate}}</p>
        </div>
      </div>
      <template v-else>
        <div class="box-body">
          <div class="col-xs-12" >
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'adress_type' | translate}}</label>
                <select class="form-control"  v-model="selectedOption">
                  <option class="normal" value="home_address">{{'home_address' | translate }}</option>
                  <option class="normal" value="packstation">{{ 'packstation' | translate }}</option>
                  <option class="normal" value="post_store">{{'post_store' | translate }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xs-12" >
            <div class="row">
              <div class="form-group col-xs-4">
                <label class="pull-left">{{'order_number' | translate}}</label>
                <input
                  class="form-control"
                  name="order_id"
                  :placeholder="'order_number' | translate"
                  type="text"
                  v-model="info.order_id"
                  @input="event => test = order_loaded=false"
                >
              </div>
              <div class="form-group col-xs-8" style="margin-top:28px;">
                <button
                  class="btn btn-flat btn-success"
                  style="padding-top: 3px;padding-bottom: 3px;"
                  v-if="info.order_id !== ''"
                  :disabled="(errors.has('last_name_packstation') || errors.has('packstation') || errors.has('post_number') || errors.has('zip_code_packstation') || errors.has('street_no_packstation') ||  errors.has('city_packstation'))"
                  type="button"
                  @click="setLabelByOrder()"
                >
                  <i :class="['fa mr-5', 'fa-save']"></i>{{'import' | translate}}
                </button>
              </div>
            </div>
          </div>
          <hr/>
          <!-- START HOME ADRESS -->
          <div class="col-xs-12" v-if="selectedOption === 'home_address'">
            <form>
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="pull-left">{{'label_type' | translate}}</label>
                  <select class="form-control" v-model="info.type">
                    <option class="normal" value="shipping">{{'shipping' | translate}}</option>
                    <option class="normal" value="return">{{'return' | translate}}</option>
                    <option class="normal" value="both">{{'shipping' | translate}} & {{'return' | translate}}</option>
                  </select>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="form-group col-xs-6">
                  <label class="pull-left">{{'company' | translate}}</label>
                  <input
                    class="form-control"
                    name="company"
                    :placeholder="'company' | translate"
                    type="text"
                    v-model="info.company"
                  >
                </div>
                <div class="form-group col-xs-6">
                  <label class="pull-left">{{'care_of' | translate}}</label>
                  <input
                    class="form-control"
                    name="care_of"
                    :placeholder="'care_of' | translate"
                    type="text"
                    v-model="info.care_of"
                  >
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-7">
                  <label class="pull-left">{{'name' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="last_name"
                    :placeholder="'name' | translate"
                    type="text"
                    v-model="info.last_name"
                  >
                  <span
                    v-show="errors.has('last_name')"
                    class="small text-danger"
                  >
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-xs-5">
                  <label class="pull-left">{{'phone_number' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="last_name"
                    :placeholder="'phone_number' | translate"
                    type="text"
                    v-model="info.phone"
                  >
                  <span
                    v-show="errors.has('last_name')"
                    class="small text-danger"
                  >
                    {{'this_field_required' | translate}}
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-9 col-xs-12">
                  <label class="pull-left">{{'street' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="street"
                    :placeholder="'street'| translate"
                    type="text"
                    v-model="info.street"
                  >
                  <span v-show="errors.has('street')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-3 col-xs-12">
                  <label class="pull-left">{{'street_no' | translate}}*</label>
                  <input
                    v-validate="{required: true, regex: '^[a-zA-Z0-9 ]*$'}"
                    class="form-control"
                    name="street_no"
                    :data-vv-as="'street_no' | translate"
                    :placeholder="'street_no' | translate"
                    type="text"
                    v-model="info.street_no"
                  >
                  <span v-show="errors.has('street_no')" class="small text-danger">
                    {{errors.first('street_no')}}
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'zip_code' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="zip_code"
                    :placeholder="'zip_code'| translate"
                    type="text"
                    v-model="info.zip_code"
                  >
                  <span v-show="errors.has('zip_code')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-6 col-xs-12">
                  <label class="pull-left">{{'city' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="city"
                    :placeholder="'city'| translate"
                    type="text"
                    v-model="info.city"
                  >
                  <span v-show="errors.has('city')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'country' | translate}}*</label>
                  <select class="form-control" v-model="info.country">
                    <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-xs-12">
                  <label>{{'parcel_options' | translate}}</label>
                  <select class="form-control" v-model="info.parcel_id">
                    <option
                      class="normal"
                      v-for="opt in parcelOptions"
                      :value="opt.id"
                    >
                      {{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <!-- END -->
          <!-- START PACKSTATION -->
          <div class="col-xs-12" v-if="selectedOption === 'packstation'">
            <div class="form-group">
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="pull-left">{{'label_type' | translate}}</label>
                  <select class="form-control" v-model="info_for_packstation.type">
                    <option class="normal" value="shipping">{{'shipping' | translate}}</option>
                    <option class="normal" value="return">{{'return' | translate}}</option>
                    <option class="normal" value="both">{{'shipping' | translate}} & {{'return' | translate}}</option>
                  </select>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="form-group col-xs-12">
                  <label class="pull-left">{{'name' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="last_name_packstation"
                    :placeholder="'name' | translate"
                    type="text"
                    v-model=" info_for_packstation.last_name"
                  >
                  <span v-show="errors.has('last_name_packstation')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3 col-xs-12">
                  <label class="pull-left">{{'packstation' | translate}}*</label>
                  <input
                    v-validate="{ required:true }"
                    class="form-control"
                    name="packstation"
                    :placeholder="'packstation'| translate"
                    type="text"
                    v-model="info_for_packstation.street_no"
                  >
                  <span v-show="errors.has('packstation')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-9 col-xs-12">
                  <label class="pull-left">{{'post_number' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="post_number"
                    :placeholder="'post_number'| translate"
                    type="text"
                    v-model="info_for_packstation.care_of"
                  >
                  <span v-show="errors.has('post_number')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'zip_code' | translate}}*</label>
                  <input
                    v-validate="'required'"
                    class="form-control"
                    name="zip_code_packstation"
                    :data-vv-as="'zip_code' | translate"
                    :placeholder="'zip_code' | translate"
                    type="text"
                    v-model="info_for_packstation.zip_code"
                  >
                  <span v-show="errors.has('zip_code_packstation')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-6 col-xs-12">
                  <label class="pull-left">{{'city' | translate}}*</label>
                  <input
                    v-validate="{required: true }"
                    class="form-control"
                    name="city_packstation"
                    :placeholder="'city'| translate"
                    type="text"
                    v-model="info_for_packstation.city"
                  >
                  <span v-show="errors.has('city_packstation')" class="small text-danger">
                    {{'this_field_required' | translate}}
                  </span>
                </div>
                <div class="form-group col-sm-3 col-xs-6">
                  <label class="pull-left">{{'country' | translate}}*</label>
                  <select class="form-control" v-model=" info_for_packstation.country">
                    <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-xs-12">
                  <label>{{'parcel_options' | translate}}</label>
                  <select class="form-control" v-model=" info_for_packstation.parcel_id">
                    <option
                      class="normal"
                      v-for="opt in parcelOptions"
                      :value="opt.id"
                    >
                      {{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- END -->
          <!-- START POST STORE -->
          <div class="col-xs-12" v-if="selectedOption === 'post_store'">
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'label_type' | translate}}</label>
                <select class="form-control" v-model="info_for_poststore.type">
                  <option class="normal" value="shipping">{{'shipping' | translate}}</option>
                  <option class="normal" value="return">{{'return' | translate}}</option>
                  <option class="normal" value="both">{{'shipping' | translate}} & {{'return' | translate}}</option>
                </select>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="form-group col-xs-12">
                <label class="pull-left">{{'name' | translate}}*</label>
                <input
                  v-validate="'required'"
                  class="form-control"
                  name="last_name_poststore"
                  :placeholder="'name' | translate"
                  type="text"
                  v-model="info_for_poststore.last_name"
                >
                <span v-show="errors.has('last_name_poststore')" class="small text-danger">
                  {{'this_field_required' | translate}}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-3 col-xs-12">
                <label class="pull-left">{{'poststore' | translate}}*</label>
                <input
                  v-validate="'required'"
                  class="form-control"
                  name="poststore_poststore"
                  :placeholder="'poststore'| translate"
                  type="text"
                  v-model="info_for_poststore.street_no"
                >
                <span v-show="errors.has('poststore_poststore')" class="small text-danger">
                  {{'this_field_required' | translate }}
                </span>
              </div>
              <div class="form-group col-sm-9 col-xs-12">
                <label class="pull-left">{{'post_number' | translate}}*</label>
                <input
                  v-validate="'required'"
                  class="form-control"
                  name="post_number_poststore"
                  :placeholder="'post_number'| translate"
                  type="text"
                  v-model="info_for_poststore.care_of"
                >
                <span v-show="errors.has('post_number_poststore')" class="small text-danger">
                  {{'this_field_required' | translate}}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-3 col-xs-6">
                <label class="pull-left">{{'zip_code' | translate}}*</label>
                <input
                  v-validate="'required'"
                  class="form-control"
                  name="zip_code_poststore"
                  :data-vv-as="'zip_code' | translate"
                  :placeholder="'zip_code' | translate"
                  type="text"
                  v-model="info_for_poststore.zip_code"
                >
                <span v-show="errors.has('zip_code_poststore')" class="small text-danger">
                  {{'this_field_required' | translate}}
                </span>
              </div>
              <div class="form-group col-sm-6 col-xs-12">
                <label class="pull-left">{{'city' | translate}}*</label>
                <input
                  v-validate="'required'"
                  data-vv-as="city_poststore"
                  class="form-control"
                  name="city_poststore"
                  :placeholder="'city'| translate"
                  type="text"
                  v-model="info_for_poststore.city"
                >
                <span v-show="errors.has('city_poststore')" class="small text-danger">
                  {{'this_field_required' | translate}}
                </span>
              </div>
              <div class="form-group col-sm-3 col-xs-6">
                <label class="pull-left">{{'country' | translate}}*</label>
                <select class="form-control" v-model=" info_for_poststore.country">
                  <option class="normal" v-for="c in Object.keys(countries)" :value="c">{{countries[c]}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-xs-12">
                <label>{{'parcel_options' | translate}}</label>
                <select class="form-control" v-model=" info_for_poststore.parcel_id">
                  <option
                    class="normal"
                    v-for="opt in parcelOptions"
                    :value="opt.id"
                  >
                    {{opt.carrier}} {{opt.parcel_type}} {{opt.weight}}KG ({{opt.length}}x{{opt.width}}x{{opt.height}})
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- END -->
        </div>
        <div class="box-footer">
          <template v-if="callback.return.label_url && callback.return.label_url !== ''">
            <div class="row">
              <div class="col-xs-6">
                <label class="pull-left">Return Label</label>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking ID: </label>
                    <span> {{callback.return.tracking_id}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking No: </label>
                    <span> {{callback.return.tracking_number}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Tracking URL: </label>
                    <span><a :href="callback.return.tracking_url" target="_blank"> {{callback.return.tracking_url}}</a></span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3">
                <a
                  class="btn btn-info btn-app pull-right"
                  :href="callback.return.label_url"
                  target="_blank"
                  download="label.pdf"
                >
                  <i class="fa fa-cloud-download"></i>
                  Get Label
                </a>
              </div>
              <div class="col-xs-3">
                <a
                  class="btn btn-warning btn-app pull-right"
                  href="/labels"
                >
                  <i class="fa fa-retweet"></i>
                  New Label
                </a>
              </div>
            </div>
          </template>
          <template v-if="callback.shipping.label_url && callback.shipping.label_url !== ''">
            <div class="row">
              <div class="col-xs-6">
                <label class="pull-left">Shipping Label</label>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Shipping Tracking ID: </label>
                    <span> {{callback.shipping.tracking_id}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Shipping Tracking No: </label>
                    <span> {{callback.shipping.tracking_number}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <label class="pull-left">Shipping Tracking URL: </label>
                    <span><a :href="callback.shipping.tracking_url" target="_blank"> {{callback.shipping.tracking_url}}</a></span>
                  </div>
                </div>
              </div>
              <div class="col-xs-3">
                <a
                  class="btn btn-info btn-app pull-right"
                  :href="callback.shipping.label_url"
                  target="_blank"
                  download="shipping-label.pdf"
                >
                  <i class="fa fa-cloud-download"></i>
                  Get Label
                </a>
              </div>
              <div class="col-xs-3">
                <a
                  class="btn btn-warning btn-app pull-right"
                  href="/labels"
                >
                  <i class="fa fa-retweet"></i>
                  New Label
                </a>
              </div>
            </div>
          </template>
          <div v-else class="row">
            <div class="col-xs-12">
              <b-btn
                v-if="selectedOption === 'home_address'"
                :disabled="(errors.has('last_name') || errors.has('street') || errors.has('street_no') || errors.has('zip_code') || errors.has('city'))"
                class="btn btn-success btn-app pull-right"
                type="button"
                @click="onClick()"
              >
                <i class="fa fa-save"></i>
                {{'submit' | translate}}
              </b-btn>
              <b-btn
                v-if="selectedOption === 'packstation'"
                :disabled="(errors.has('last_name_packstation') || errors.has('packstation') || errors.has('post_number') || errors.has('zip_code_packstation') || errors.has('street_no_packstation') ||  errors.has('city_packstation'))"
                class="btn btn-success btn-app pull-right"
                type="button"
                @click="onClick()"
              >
                <i class="fa fa-save"></i>
                {{'submit' | translate}}
              </b-btn>
              <b-btn
                v-if="selectedOption === 'post_store'"
                :disabled="(errors.has('last_name_poststore') || errors.has('poststore_poststore') || errors.has('post_number_poststore') || errors.has('zip_code_poststore') || errors.has('street_no_poststore') || errors.has('city_poststore'))"
                class="btn btn-success btn-app pull-right"
                type="button"
                @click="onClick()"
              >
                <i class="fa fa-save"></i>
                {{'submit' | translate}}
              </b-btn>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Materials',
  props: ['label', 'addressType'],
  data: function () {
    return {
      company: {
        id: 0,
        name: 'Wählen Sie ein Unternehmen aus',
      },
      companies: [],
      selectedOption: this.addressType || 'home_address',
      parcelOptions: [],
      order_loaded: false,
      info: {
        order_id: '',
        type: 'shipping',
        company: '',
        care_of: '-',
        company_id: '',
        last_name: '',
        street: '',
        street_no: '',
        city: '',
        zip_code: '',
        phone: '',
        country: 'DE',
        parcel_id: 1
      },
      info_for_packstation: {
        order_id: '',
        type: 'shipping',
        company_id: '',
        last_name: '',
        street: 'Packstation',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: 1,
        care_of: ''
      },
      info_for_poststore: {
        order_id: '',
        type: 'shipping',
        company_id: '',
        last_name: '',
        street: 'Postfiliale',
        street_no: '',
        city: '',
        zip_code: '',
        country: 'DE',
        parcel_id: 1,
        care_of: ''
      },
      callback: {
        shipping: {
          label_url: '',
          tracking_id: '',
          tracking_url: '',
          tracking_number: ''
        },
        return: {
          label_url: '',
          tracking_id: '',
          tracking_url: '',
          tracking_number: ''
        },
        order: {
          shipping_id: 0
        }
      },
      countries: require('../../filters/countries.json'),
      alerts: [],
      order: {},
    }
  },
  computed: {
  },
  methods: {
    setLabelByOrder() {
      let order;
      if (this.info.order_id !== '') {
        API.get(`orders/${this.info.order_id}`)
          .then(res => {
            order = res.data

            let find_child = false;

            order.child_ids.forEach((child_id) => {
              if (child_id.id === parseInt(this.info.order_id)) {
                find_child = true;
              }
            });

            if (find_child === false){
              throw new Error('Order not found, or not a Child Order!');
            }

            if (this.selectedOption === 'home_address') {
              if (this.info_for_poststore.type === 'shipping') {
                this.info.type = 'shipping';
              } else if (this.info_for_poststore.type === 'return') {
                this.info.type = 'return'
              }

              this.info.company = '';
              this.info.care_of = order.customer.corrected_care_of !=='' ? order.customer.corrected_care_of : '-';
              this.info.company_id = order.customer.corrected_company;
              this.info.last_name = order.customer.corrected_first_name !=='' || order.customer.corrected_last_name !=='' ? order.customer.corrected_first_name + ' ' + order.customer.corrected_last_name : order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info.street = order.customer.corrected_street !== '' ? order.customer.corrected_street : order.customer.delivery_address_line_1;
              this.info.street_no = order.customer.corrected_street_number !== '' ? order.customer.corrected_street_number : order.customer.delivery_address_line_2 ;
              this.info.city = order.customer.corrected_city !== '' ? order.customer.corrected_city : order.customer.delivery_city;
              this.info.zip_code = order.customer.corrected_zip !== '' ? order.customer.corrected_zip : order.customer.delivery_zip_code;
              this.info.country = order.customer.delivery_country;
              this.info.phone = order.customer.customer_phone_number;
              this.info.parcel_id = 1;
            }

            if (this.selectedOption === 'packstation') {
              if (this.info.type === 'shipping') {
                this.info_for_packstation.type = 'shipping';
              } else if (this.info.type === 'return') {
                this.info_for_packstation.type = 'return';
              }

              this.info_for_packstation.company_id = this.info.company_id;
              this.info_for_packstation.last_name = order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info_for_packstation.street = 'Packstation';
              this.info_for_packstation.street_no = order.customer.delivery_address_line_1;
              this.info_for_packstation.city = order.customer.delivery_city;
              this.info_for_packstation.zip_code = order.customer.delivery_zip_code;
              this.info_for_packstation.country = order.customer.delivery_country;
              this.info_for_packstation.parcel_id = 1;
              this.info_for_packstation.care_of = order.customer.delivery_address_line_2;
            }

            if (this.selectedOption === 'post_store') {
              if (this.info.type === 'shipping') {
                this.info_for_poststore.type = 'shipping';
              } else if (this.info.type === 'return') {
                this.info_for_poststore.type = 'return';
              }

              this.info_for_poststore.company_id = this.info.company_id;
              this.info_for_poststore.last_name = order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info_for_poststore.street = 'Postfiliale';
              this.info_for_poststore.street_no = order.customer.delivery_address_line_1;
              this.info_for_poststore.city = order.customer.delivery_city;
              this.info_for_poststore.zip_code = order.customer.delivery_zip_code;
              this.info_for_poststore.country = order.customer.delivery_country;
              this.info_for_poststore.parcel_id = 1;
              this.info_for_poststore.care_of = order.customer.delivery_address_line_2;
            }

            this.order_loaded = true;

          }).catch(error => {
            console.log(error);
            let message = (error.response !== undefined && error.response.data !== undefined && error.response.data.message !== undefined) ? error.response.data.message : error;
            let alert = {type: 'danger', dismiss: 4, message: message}
            this.$store.commit('pushAlert', alert)
          })
      }
    },
    setLabel() {
      let order
      if (this.label !== undefined) {
        this.company = this.companies.find(c => c.id === this.label.company_id)
        API.get(`orders/${this.label.order_id}`)
          .then(res => {
            order = res.data

            if (this.selectedOption === 'home_address') {
              if (this.label.type === 'shipping') {
                this.info.type = 'shipping';
              } else if (this.label.type === 'return') {
                this.info.type = 'return'
              }

              this.info.company = '';
              this.info.care_of = '-';
              this.info.company_id = this.label.company_id;
              this.info.last_name = order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info.street = order.customer.delivery_address_line_1;
              this.info.street_no = order.customer.delivery_address_line_2;
              this.info.city = order.customer.delivery_city;
              this.info.zip_code = order.customer.delivery_zip_code;
              this.info.country = order.customer.delivery_country;
              this.info.parcel_id = 1;
            }

            if (this.selectedOption === 'packstation') {
              if (this.label.type === 'shipping') {
                this.info_for_packstation.type = 'shipping';
              } else if (this.label.type === 'return') {
                this.info_for_packstation.type = 'return';
              }

              this.info_for_packstation.company_id = this.label.company_id;
              this.info_for_packstation.last_name = order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info_for_packstation.street = 'Packstation';
              this.info_for_packstation.street_no = order.customer.delivery_address_line_1;
              this.info_for_packstation.city = order.customer.delivery_city;
              this.info_for_packstation.zip_code = order.customer.delivery_zip_code;
              this.info_for_packstation.country = order.customer.delivery_country;
              this.info_for_packstation.parcel_id = 1;
              this.info_for_packstation.care_of = order.customer.delivery_address_line_2;
            }
            if (this.selectedOption === 'post_store') {
              if (this.label.type === 'shipping') {
                this.info_for_poststore.type = 'shipping';
              } else if (this.label.type === 'return') {
                this.info_for_poststore.type = 'return';
              }

              this.info_for_poststore.company_id = this.label.company_id;
              this.info_for_poststore.last_name = order.customer.delivery_first_name + ' ' + order.customer.delivery_last_name;
              this.info_for_poststore.street = 'Postfiliale';
              this.info_for_poststore.street_no = order.customer.delivery_address_line_1;
              this.info_for_poststore.city = order.customer.delivery_city;
              this.info_for_poststore.zip_code = order.customer.delivery_zip_code;
              this.info_for_poststore.country = order.customer.delivery_country;
              this.info_for_poststore.parcel_id = 1;
              this.info_for_poststore.care_of = order.customer.delivery_address_line_2;
            }
          })
      }
    },
    createNewLabel (info) {
      API.post('accounting/label/create', info)
        .then(response => {
          if ((response.data.return !== undefined && response.data.return.status === 'error')) {
            let alert = {type: 'danger', dismiss: 4, message: JSON.parse(response.data.return.message).errors}
            this.$store.commit('pushAlert', alert)
          } else if(response.data.shipping !== undefined && response.data.shipping.status === 'error') {
            let alert = {type: 'danger', dismiss: 4, message: JSON.parse(response.data.shipping.message).errors}
            this.$store.commit('pushAlert', alert)
          } else {
            if (response.data.return !== undefined ) {
              this.callback.return = response.data.return.data;
            }
            if (response.data.shipping !== undefined) {
              this.callback.shipping = response.data.shipping.data;
            }

            let alert = {type: 'success', dismiss: 4, message: 'Success!'}
            this.$store.commit('pushAlert', alert)
          }
        })
        .catch(error => {
          let alert = {type: 'danger', dismiss: 4, message: error.response.data.message}
          this.$store.commit('pushAlert', alert)
        })
    },
    onClick() {
      this.$validator.validate()
        .then(result => {
          if (result) {
            if (this.selectedOption === 'home_address') {
              this.info.company_id = this.company.id || this.label.company_id
              this.createNewLabel(this.info)
              this.info_for_packstation = {
                type: 'shiping',
                street: 'Packstation',
                country: 'DE',
                parcel_id: 1,
              }
              this.info_for_poststore = {
                type: 'shipping',
                street: 'Postfiliale',
                country: 'DE',
                parcel_id: 1,
              }
            }
            if (this.selectedOption === 'packstation') {
              this.info_for_packstation.company_id = this.company.id || this.label.company_id
              this.info_for_packstation.order_id = this.info.order_id;
              this.createNewLabel(this.info_for_packstation)
              this.info = {
                type: 'shipping',
                street: '',
                country: 'DE',
                parcel_id: 1,
              }
              this.info_for_poststore = {
                type: 'shipping',
                street: 'Postfiliale',
                country: 'DE',
                parcel_id: 1,
              }
            }
            if (this.selectedOption === 'post_store') {
              this.info_for_poststore.company_id = this.company.id || this.label.company_id
              this.info_for_poststore.order_id = this.info.order_id;
              this.createNewLabel(this.info_for_poststore)
              this.info = {
                type: 'shipping',
                street: '',
                country: 'DE',
                parcel_id: 1,
              }
              this.info_for_packstation = {
                type: 'shipping',
                street: 'Packstation',
                country: 'DE',
                parcel_id: 1,
              }
            }
          }
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      API.get('/orders/parcel-options')
        .then(res => {
          this.parcelOptions = res.data
        })
        .catch(error => {
          console.log(error)
        })

      this.companies = this.$store.getters.companies

      this.setLabel()
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.multiselect::placeholder {
  color: #ffffff !important;
}
</style>
<style>
select option.normal{
  margin:40px;
  color:#fff;
  text-shadow:0 1px 0 rgba(0,0,0,.4);
  background:#202227
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 14px !important;
  background: transparent !important;
  color: #ffffff !important;
}
.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 40px 0 8px;
  border-radius: 0px !important;
  border: 1px solid rgba(255,255,255,.15);
  color: #ffffff;
  background: transparent !important;
  font-size: 14px;
}
.multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #212228;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid rgba(255,255,255,.15);
  border-top: none;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
</style>




// WEBPACK FOOTER //
// src/components/views/NewLabels.vue